export default __webpack_public_path__ + "c2e80318bf71b2ae3f7b2035033d8e6e.png";